// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"9080a0ca","161":"30909844","553":"edafe2e9","561":"c6f2864f","718":"a14ef99d","723":"006153fc","755":"3c331aeb","864":"81ea058c","906":"7bc17bc8"}[chunkId] + ".chunk.js";
};